import React from 'react'
import {
    ContainerFluid,Container,ContainerX,HeadingText,DescText
} from './SectionBComponent.style';
function SectionBComponentHome() {
  return (
    <div>
        <ContainerFluid>
            <Container>
                <div className='row'>
                    <div className='col s12 m12 l6 '>
                            <Container>
                            <div className='row mt-100'>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l11 mt-100'>
                                    <ContainerX className=''>
                                        <HeadingText>
                                        Secure your tomorrow,
                                        automate your savings. 
                                        </HeadingText>
                                    </ContainerX>
                                </div>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l9'>
                                    <ContainerX>
                                        <DescText>
                                        Reach important life goals by automating your 
                                        savings plan and keeping it locked for your 
                                        preferred duration.
                                        </DescText>
                                    </ContainerX>
                                </div>
                            </div>
                            </Container>
                        </div>
                        <div className='col s12 m12 l6 center' >
                            <div style={{height:"75px"}}></div>
                            <img width="66%"  style={{
                                marginBottom:"-7px"
                            }}  src="https://res.cloudinary.com/yalla-ng/image/upload/v1657196835/re-brand/idevices_mockup_23_2x_1_x7cjcz.svg" alt=""/>
                        </div>
                </div>
            </Container>
        </ContainerFluid>
    </div>
  )
}

export default SectionBComponentHome